export default __webpack_public_path__ + "static/media/icon-marketing-integrations-check.673fd2f2.svg";